import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, Subject } from 'rxjs';

import { RestApiService } from 'src/app/core/services/rest-api.service';
import { AppConfiguration } from 'src/app/model/app-detail.model';
import { Category } from 'src/app/model/category.model';
import { Store } from 'src/app/model/store.model';
import { UserCart } from 'src/app/model/user-cart.model';
import { User } from 'src/app/model/user.model';
import { DefaultDomain } from 'src/app/shared/constants/app.constant';

@Injectable({
  providedIn: 'root'
})
export class CommonApiService {
  cartUpdateSubject: Subject<boolean> = new Subject<boolean>();


  constructor(
    private restApiService: RestApiService
  ) { }

  getCategories(): Observable<any> {
    return this.restApiService.get<Category[]>('category/header');
  }

  getAppConfiguration(storeId: string): Observable<AppConfiguration> {
    const domain = window.location.hostname === 'localhost' ? DefaultDomain : window.location.origin;
    if (storeId) {
      return this.restApiService.get<AppConfiguration>(`generateToken?DomainName=${domain}&storeId=${storeId}`);
    } else {
      return this.restApiService.get<AppConfiguration>(`generateToken?DomainName=${domain}`);
    }
  }

  addToCartItem(cartItem: any): Observable<any> {
    return this.restApiService.post('addtocart/insert', cartItem);
  }

  getUserCart(): Observable<UserCart> {
    return this.restApiService.get('addtocart/list');
  }

  signOut(): Observable<any> {
    return this.restApiService.get('login/signout');
  }

  updateUserProfile(user: User): Observable<User> {
    return this.restApiService.put<User>('Profile', user);
  }

  getAllCategories(): Observable<any> {
    return this.restApiService.get<Category[]>('category');
  }

  updateAgeVerification(isConfirm: boolean): Observable<any> {
    return this.restApiService.get<Category[]>(`ageVerification?IsAgeVerification=${isConfirm}`);
  }

  getStores(): Observable<Store[]> {
    return this.restApiService.get<Store[]>('store/allStore');
  }
}
